// extracted by mini-css-extract-plugin
module.exports = {"sheetPage":"Style_sheetPage__Ii35C","container":"Style_container__3nq0E","header":"Style_header__1Oao7","subheader":"Style_subheader__1tNBi","linkBox":"Style_linkBox__3qp20"};